module.exports = __webpack_public_path__ + "assets/img/more03.523b5dc8.jpg";